import _ from 'lodash'
import Table from './table'
import Toolbar from './toolbar'
import { send } from 'helpers/utils'
import { useEffectOnce } from 'react-use'
import { useLocation } from 'react-router-dom'
import { MoveInstructionTextListPromise } from 'api/MoveWorkout'
import React, { useState, useEffect, useRef, useCallback } from 'react'

const RecordList = props => {
  const ref = useRef()
  const location = useLocation()
  const [params, setParams] = useState({})
  const [records, setRecords] = useState({})

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    console.log(too)

    setParams({ page: 1, ...too })
  }, [])

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    MoveInstructionTextListPromise(too).then(resp => setRecords(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload) {
    handleParamsChange(payload, 500)
  }
  // end
  
  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar handleSearchChange={handleSearchChange} onParamsChange={handleParamsChange} params={params} {...props} />
        <br />
        <Table
          {...props}
          data={records}
          page={send(params, 'page') || 1}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  )
}

export default RecordList 